import { useEffect, useState } from "react";
import { TripItinerary } from "@/fetch/inventory";
import mapboxgl, { Marker } from "mapbox-gl";
import ReactDOM from "react-dom";
import CustomMarker from "./CustomMarker";

export const useItineraryMapMarkers = (itinerary: TripItinerary[]) => {
  const [markers, setMarkers] = useState<Marker[]>([]);
  const addStep = (
    coord: any,
    mapComponent: mapboxgl.Map,
    index: number,
    selectedIndex: number
  ) => {
    // Create a custom HTML element from the React component
    const customMarker = document.createElement("div");

    ReactDOM.render(
      <CustomMarker
        index={index}
        active={index + 1 === selectedIndex}
        isOverview={true}
      />,
      customMarker
    );

    const city = new Marker({
      offset: [0, -10],
      color: "#FB2F54",
      element: customMarker,
      scale: 0.6,
    });
    city.setLngLat({
      lat: coord.latitude,
      lng: coord.longitude,
    });

    customMarker.style.zIndex = "1";

    const cityMarker = city.addTo(mapComponent);

    setMarkers((prevMarkers) => [...prevMarkers, cityMarker]);
  };

  return { addStep, markers };
};
